// extracted by mini-css-extract-plugin
export default {"overlay":"Generate_overlay__mW9le"};